import { render, staticRenderFns } from "./DrivewealthNavigation.vue?vue&type=template&id=1626e592&scoped=true"
import script from "./DrivewealthNavigation.vue?vue&type=script&lang=ts"
export * from "./DrivewealthNavigation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1626e592",
  null
  
)

export default component.exports